<template>
  <span>
    <small v-if="hasErrors" class="el-form-item__error">{{
      errorMessage
    }}</small>
    <span v-if="readonly && tagFormatValue.length == 0" class="field-tail">
      {{ inputValue }}
      <slot name="append" class="el-input-group__append"></slot>
    </span>
    <span
      v-if="
        readonly &&
          tagFormatValue.constructor == Array &&
          tagFormatValue.length > 0
      "
    >
      <span v-for="(label, index) in tagFormatValue" :key="index">{{
        label
      }}</span>
    </span>
  </span>
</template>
<script>
import utils from "@/utils.js";

export default {
  name: "eco-field-tail",
  props: {
    fieldName: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    inputValue: {
      type: [String, Number, Object, Array, Boolean]
    },
    tagFormatValue: {
      type: [Array],
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      scopeName: null
    };
  },
  computed: {
    fieldScopePath: function() {
      let path = this.fieldName;
      if (this.scopeName) {
        path = `${this.scopeName}.${this.fieldName}`;
      }
      return path;
    },
    hasErrors: function() {
      return this.errors && this.errors.has(this.fieldScopePath);
    },
    errorMessage: function() {
      return this.errors.first(this.fieldScopePath);
    }
  },
  mounted() {
    this.scopeName = utils.getSomeAttributeFromParentElement(
      this.$el.parentElement,
      "data-vv-scope"
    );
  },
  created() {
    this.$validator = this.$root.$validator;
  }
};
</script>

<style lang="stylus" scoped>
.field-tail {
  display: block;
  word-break: break-all;
  word-wrap: break-word;
}

td .el-form-item__error, th .el-form-item__error {
  transform: scale(0.9);
}

td .el-form-item__error, th .el-form-item__error {
  top: calc(100% - 3px);
}
</style>
